<!--
 * @Author: your name
 * @Date: 2021-11-02 15:10:02
 * @LastEditTime: 2024-08-19 14:30:05
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: In User Settings Edit
 * @FilePath: /my-activation/src/Actives/index.vue
-->
<template>
  <div class="actives">
    <img :src="logoUrl" class="imgActive" v-if="type == 'image'" />
    <img :src="logoUrl" class="bannerActive" v-if="type == 'banner'" />
    <!-- <div class="banners"></div> -->
    <div class="noUse_item" v-for="(item, idx) of cardList" :key="item.id">
      <div class="noUse_top">
        <div class="noUse_topOne">
          <p class="noUse_num">
            ￥<span>{{ item.discountRule && item.discountRule.discount }}</span>
          </p>
          <p class="noUse_canUse">优惠券</p>
        </div>
        <div>
          <p class="noUse_center">{{ item.name }}</p>
          <p class="noUse_centerTime" v-show="item.validPeriodType === 2">
            领取后{{ item.validPeriodRule.duration }}天内有效
          </p>
          <p class="noUse_centerTime" v-show="item.validPeriodType === 1">
            <!--  hh:mm:ss -->
            {{ moment(item.validPeriodRule.from).format('YYYY-MM-DD') }}-
            {{ moment(item.validPeriodRule.to).format('YYYY-MM-DD') }}
          </p>
          <p class="userules" @click="showDetail(item, rules[idx])">
            使用规则>
          </p>
        </div>
        <div class="useButton" :class="item.getStatus === true ? 'getTrue' : 'getFalse'"
          @click="getCoupon(item.id, item.getStatus)">
          立即领取
        </div>
      </div>
      <!-- <hr style="background:#EEEEEE;border:none;height:1px" /> -->
      <!-- <p class="useRules">限{{ rules[idx] }}使用</p> -->
      <p v-show="showToast" class="toasts">{{ toastText }}</p>
    </div>
    <div class="returns">
      <Return></Return>
    </div>
    <div v-if="details" class="mask"></div>
    <div v-if="details" class="detail_box">
      <p class="usetit">使用规则</p>
      <p class="detail_p">{{ rule }}</p>
      <p class="detail_p">{{ shops }}</p>
      <p class="agree" @click="agrees()">我知道了</p>
    </div>
    <!-- swiper -->
  </div>
</template>
<script>
import Swiper from '../swiper'
import SwiperSlider from '../swiperslider'
import wx from 'weixin-jsapi'
// import wx from 'weixin-js-sdk'

// import moment from "moment";
export default {
  name: 'actives',
  components: {
    Swiper,
    SwiperSlider,
  },
  data() {
    return {
      logoUrl: '/static/image/jilu.png',
      type: 'all',
      id: '',
      cardList: [],
      rules: [],
      showToast: false,
      toastText: '恭喜您，领取成功!',
      RegisterStatus: false,
      sharePicUrl: '',
      shareTitle: '',
      code: '',
      shareAble: true,
      details: false,
      distributeType: '', //  1.'手动领取',2.'新用户注册',3.'充值',4.'消费'
      rule: '',
      shops: '',
    }
  },
  mounted() {
    const companyID = localStorage.getItem('companyID')
    const query = this.$route.query
    let codes = localStorage.getItem('code')
    let appcode = localStorage.getItem('appcode')
    console.log('query.companyID', companyID);
    if (!codes || !appcode) {
      const baseUrl = window.location.origin
      // window.location.href = `${baseUrl}/vip-h5/api/v2/h5/vip?companyID=${companyID ? companyID : query.companyID}`
      window.location.href = `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${query.companyID}&canary=true&pre=true`
      return
    }
    this.logoUrl = query.url
    this.type = query.type
    this.id = query.id
    this.sharePicUrl = query.sharePicUrl ? query.sharePicUrl : ''
    this.shareTitle = query.shareTitle ? query.shareTitle : ''
    this.shareText = query.shareText ? query.shareText : ''
    this.code = codes
    this.appcode = query.appcode
    console.log('query.sharePicUrl', query.sharePicUrl);
    // 是否有实体卡
    this.RequestVIP(
      `h5/vip/info?openID=${codes}&CompanyID=${companyID}`,
      (res) => {
        if (
          res.data.data.table1 &&
          res.data.data.table1[0] &&
          res.data.data.table1[0].TEL
        ) {
          this.RegisterStatus = true
        } else {
          this.$router.push({
            path: '/Registers',
          })
        }
      },
      (err) => console.log(err)
    )
    this.shareAble = query.shareAble
    this.distributeType = query.distributeType
    let url = window.location.href.split('#')[0]
    console.log('window.location.href', window.location.href);
    // 分享配置
    const share_config = {
      share: {
        imgUrl: query.sharePicUrl, //分享图，默认当相对路径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
        desc: query.shareText, //摘要,如果分享到朋友圈的话，不显示摘要。
        title: query.shareTitle ? query.shareTitle : '', //分享卡片标题
        link: `${window.location.href}&companyID=${companyID}`, //分享出去后的链接，这里可以将链接设置为另一个页面。
        success: function () {
          //分享成功后的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        },
      },
    }
    this.RequestVIP2(
      'h5/vip/config',
      { url, CompanyID: companyID },
      (r) => {
        // console.log(r, "rerererererryjkkkk");
        if (r.data.code == '20000') {
          const { data } = r
          // const shareAble = this.shareAble;
          console.log(wx, 'wxwxwxwkkkkk')
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.data.app_id, // 必填，公众号的唯一标识
            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.data.nonce_str, // 必填，生成签名的随机串
            signature: data.data.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
          })
          const that = this
          console.log('shareTitle', wx.updateAppMessageShareData);
          wx.ready(function () {
            wx.updateAppMessageShareData(share_config.share) //分享给好友
            wx.updateTimelineShareData(share_config.share) //分享到朋友圈

            // if (wx.updateAppMessageShareData) {
            //   wx.updateAppMessageShareData(
            //     {
            //       title: that.shareTitle ? that.shareTitle : '',
            //       link: `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${companyID}&canary=true`,
            //       desc: that.shareText, // 分享描述
            //       imgUrl: that.sharePicUrl,
            //     },
            //     function (res) {
            //       console.info('success')
            //     }
            //   )
            // }
            // if (wx.updateTimelineShareData) {
            //   wx.updateTimelineShareData(
            //     {
            //       title: that.shareTitle ? that.shareTitle : '',
            //       link: `https://api.cnuri.cn/vip-h5/api/v2/h5/vip?companyID=${companyID}&canary=true`,
            //       imgUrl: that.sharePicUrl,
            //     },
            //     function (res) {
            //       console.info('success')
            //     }
            //   )
            // }
            // }
          })
        } else {
          alert(r.data.msg)
        }
      },
      (err) => {
        alert(err)
      }
    )

    // wx.showShareMenu({ menus: ["shareAppMessage", "shareTimeline"] });
    this.getcard()
  },

  methods: {
    showDetail(item, shop) {
      this.shops = '限用店铺:' + shop
      if (
        item.discountRule.spendSatisfy == 0 &&
        item.discountRule.goodsSumSatisfy == 0
      ) {
        this.rule = '使用规则：无门槛使用'
      } else {
        this.rule = `使用规则：满${item.discountRule && item.discountRule.spendSatisfy
          ? item.discountRule.spendSatisfy + '元'
          : 0 + '元'
          }，${item.discountRule && item.discountRule.goodsSumSatisfy
            ? item.discountRule.goodsSumSatisfy + '件'
            : 0 + '件'
          }可用`
      }
      this.details = true
      // console.log(data, "dadadaaddadadad");
    },
    agrees() {
      this.details = false
    },
    getcard() {
      const openId = localStorage.getItem('code')
      const cardNo = localStorage.getItem('VIPNO')
      this.RequestVIP(
        `h5/campaign/${this.$route.query.id}/coupon/all?openID=${openId}&cardNo=${cardNo}`,
        (r) => {
          if (r.data.code == '20000') {
            const { data } = r.data
            this.cardList =
              data &&
              data.filter((item) => {
                // 状态在线
                if (item.status === 3) {
                  // 优惠券是否过期
                  if (
                    (!!item.validPeriodRule.to &&
                      item.validPeriodRule.to > new Date().getTime()) ||
                    item.validPeriodRule.duration
                  )
                    if (
                      item.couponStats.collectedAmount < item.userTotalLimit &&
                      item.couponStats.discountAmount +
                      item.discountRule.discount <
                      item.discountTotalLimit //总领取金额数量小于限制领取金额数量
                    ) {
                      if (
                        item.eachUserLimit === 0 ||
                        item.userStats.collectedAmount < item.eachUserLimit //不限领或用户领取数小于总领取数
                      ) {
                        item.getStatus = true
                      } else {
                        item.getStatus = false
                      }
                      return item
                    } else {
                      item.getStatus = false
                      return item
                    }
                }
              })
            // 拿到店铺名称
            this.RequestVIP(
              'h5/shop/all?page=1&size=999',
              (res) => {
                const { result } = res.data.data
                let arr = []
                data.map((item, idx) => {
                  result.map((it) => {
                    if (item.shops.indexOf(it.id) > -1) {
                      arr[idx] = arr[idx] ? arr[idx] + ',' + it.name : it.name
                    }
                  })
                })

                this.rules = arr
                // console.log(arr, "111111111111111111");
              },
              (err) => console.log
            )
          }
        },
        (err) => console.log(err)
      )
    },
    getCoupon(cid, getStatus) {
      // console.log(getStatus, "getstatusssss");
      const openId = localStorage.getItem('code')
      const cardNo = localStorage.getItem('VIPNO')
      if (this.RegisterStatus === true) {
        if (this.showToast === true) {
          return
        }
        if (getStatus === false) {
          this.toastText = '优惠券已到领取上限'
          this.showToast = true
          setTimeout(() => {
            this.showToast = false
          }, 2000)
          return
        }
        this.RequestVIP(
          `h5/campaign/${this.id}/coupon/${cid}/collect?openID=${openId}&cardNo=${cardNo}`,
          (r) => {
            // console.log(r, "rfkmlfklslllll");
            if (r.data.code == '20000') {
              this.toastText = '恭喜您，领取成功!'
              this.showToast = true
            } else {
              this.toastText = r.data.msg
              this.showToast = true
            }
            setTimeout(() => {
              this.showToast = false
              this.getcard()
            }, 2000)
          },
          (err) => console.log(err)
        )
      } else {
        this.toastText = '您还未注册，请先完成注册!'
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
          this.$router.push({
            path: '/Registers',
          })
        }, 1000)
      }
    },
  },
}
</script>
<style scoped>
.actives {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.imgActive {
  width: 100%;
  height: 187px;
}

.noUse_item {
  width: 233px;
  /* height: 103px; */
  background: #ffffff;
  /* border: 1px solid #eeeeee; */
  opacity: 1;
  margin: 11px 0 0 8px;
}

.noUse_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px 10px 12px;
  box-sizing: border-box;
}

.noUse_num {
  font-size: 9px;
  color: #f2553d;
  line-height: 23px;
}

.noUse_num span {
  font-size: 14px;
  font-weight: 600;
}

.noUse_canUse {
  height: 14px;
  font-size: 8px;
  line-height: 11px;
  color: #f2553d;
}

.noUse_center {
  width: 110px;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  /* height: 44px; */
  color: #757575;
}

.noUse_centerTime {
  width: 100px;
  overflow: hidden;
  height: 10px;
  font-size: 8px;
  font-weight: 400;
  line-height: 10px;
  color: #9e9e9e;
}

.useButton {
  width: 47px;
  height: 17px;

  opacity: 1;
  border-radius: 15px;
  font-size: 8px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 17px;
  margin-top: 10px;
}

.getTrue {
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
}

.getFalse {
  background: lightgray;
}

.useRules {
  height: 23px;
  line-height: 23px;
  box-sizing: border-box;
  padding: 0 8px;
  color: #9e9e9e;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.swiperitem {
  width: 234px;
  height: 67px;
  border-radius: 6px;
  margin: 15px 0 0 8px;
}

.bannerActive {
  width: 96%;
  margin-left: 2%;
  height: 117px;
  border-radius: 5px;
}

.toasts {
  width: 100px;
  /* height: 30px; */
  line-height: 15px;
  padding: 10px;
  border-radius: 5px;
  background: rgb(49, 47, 47);
  opacity: 0.5;
  color: white;
  position: fixed;
  top: 46%;
  left: 30%;
  text-align: center;
  font-size: 10px;
}

/* .noUse_topOne {
  width: 25%;
} */
.returns {
  position: fixed;
  top: 80%;
  left: 0;
}

.detail_box {
  width: 70%;
  min-height: 150px;
  font-size: 10px;
  font-weight: 500;
  color: #757575;
  background: white;
  position: fixed;
  top: 20%;
  left: 15%;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
}

.agree {
  width: 100%;
  height: 25px;
  line-height: 25px;
  color: white;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  position: relative;
  bottom: 0;
  text-align: center;
}

.detail_p {
  margin: 5px;
}

.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.4;
}

.usetit {
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  margin: 10px 0;
  text-align: center;
}

.noUse_topOne {
  padding-right: 8px;
  border-right: dotted 1.2px #e0e0e0;
}

.userules {
  color: #757575;
  font-size: 8px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/Actives/index.vue